import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useContext} from 'react';
import {fnOrValue} from '~/utils/fn-or-value';
import {FieldContext} from './FieldContext';
import {ToolbarLabelWrapper} from './styles';
import {Tooltip} from './Tooltip';

export const FieldLabel = ({labelLast, ...props}) => {
  const context = useContext(FieldContext);

  const {className, icon, label, tooltip, parentRef} = {
    ...context,
    ...props,
  };

  const iconValue = fnOrValue(icon, context);
  const labelValue = fnOrValue(label, context);
  const tooltipValue = fnOrValue(tooltip, context);

  return (
    <>
      {iconValue || labelValue
        ? (
          <ToolbarLabelWrapper
            className={className}
            labelLast={labelLast}
          >
            {iconValue
              ? iconValue.icon
                ? <FontAwesomeIcon icon={iconValue} />
                : (
                  <img
                    width={24}
                    height={24}
                    src={iconValue}
                    alt=""
                  />
                )
              : null}
            {iconValue && labelValue ? <>&nbsp;</> : null}
            {labelValue || null}
          </ToolbarLabelWrapper>
        )
        : null}
      {tooltipValue && (
        <Tooltip
          parentRef={parentRef}
          onHover
          alignCenter
          alignBottom
        >
          {tooltipValue}
        </Tooltip>
      )}
    </>
  );
};